import { t } from "components/CentralDataMangement/translation/Translation";
import Title from "components/common/atoms/Title";
import OfficeTargetTable from "../common/OfficeTargetTable";
import {
  JobInterviewDetails,
  OfficeTarget,
  StarterDetails,
  StopperDetails,
  User,
} from "../Annotations";
import { useEffect, useState } from "react";
import { dummyTargetData, dummyTeamLeadsData } from "../DummyData";
import StartersTable from "../common/StartersTable";
import StoppersTable from "../common/StoppersTable";
import { Accordion } from "react-bootstrap";
import JobInterviewTable from "../common/JobInterviewTable";
import EncryptDecryptService from "components/common/services/EncryptDecryptService";
import secureLocalStorage from "react-secure-storage";
import CustomNotify from "components/common/atoms/CustomNotify";
import { ApiCall } from "components/common/services/ApiServices";
import { EDIT_WEEKLY_REPORTS } from "../../../../routes/ApiEndpoints";
import { CENTRAL_DATA_MANAGEMENT_MICROSERVICE } from "Constants";
import AccessControl from "components/common/services/RolesAndPermissions/AccessControl";

interface TargetData {
  officeQTarget: OfficeTarget;
  officeTarget: OfficeTarget;
}

interface TeamLeadsData {
  teamLeads: User[];
  starters: StarterDetails[];
  stoppers: StopperDetails[];
  jobInterviews: JobInterviewDetails[];
}

const WeeklyReports: React.FC = () => {
  const [targetData, setTargetData] = useState<TargetData>();
  const [teamLeadsData, setTeamLeadsData] = useState<TeamLeadsData>({
    teamLeads: [],
    starters: [],
    stoppers: [],
    jobInterviews: [],
  });
  let data = secureLocalStorage.getItem('weeklyReport') as string; // Get the 'data' query param as a string


  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {

    let parsedData = {};
    try {
      if (data) {
        // Decrypt the recruiterData
        let decryptedData = EncryptDecryptService.decryptData(data);

        // If decryptedData is in JSON format, parse it
        parsedData = JSON.parse(decryptedData);
      }

    } catch (error) {
      CustomNotify({
        type: "error",
        message: t("Something went wrong"),
      });
      return null;
    }
    const response = await ApiCall.service(
      EDIT_WEEKLY_REPORTS,
      "POST",
      { ...parsedData, type: "teamLead" },
      false,
      CENTRAL_DATA_MANAGEMENT_MICROSERVICE
    );

    if (response.status === 200) {

      // setReports(response?.data?.reports);
      // setCandidates(response?.data?.candidates);
      setTeamLeadsData(response?.data?.teamLeadsData);
    }
    // setLoading(false);


    setTargetData({
      officeQTarget: dummyTargetData.officeTarget,
      officeTarget: dummyTargetData.officeTarget,
    });
    // setTeamLeadsData(dummyTeamLeadsData);
  };

  const getStarters = (id: number | string) => {
    return teamLeadsData.starters.filter((data) => data.created_by === id);
  };

  const getStoppers = (id: number | string) => {
    return teamLeadsData.stoppers.filter((data) => data.created_by === id);
  };

  return (
    <AccessControl
      requiredPermissions={[
        {
          permission: "Reports",
          read: true,
        },
      ]}
      renderNoAccess={true}
    >
      <Title title={t("Reporting (weekly team lead)")} />
      <div className="row mb-4">
        <div className="col-md-6">
          <OfficeTargetTable
            data={targetData?.officeQTarget}
            tableTitle={t("Office")}
          />
        </div>
        <div className="col-md-6 float-right">
          <OfficeTargetTable
            data={targetData?.officeQTarget}
            tableTitle={t("Office Q")}
          />
        </div>
      </div>
      <div className="row">
        {/* <div className="col-md-2">
                    <table className="table mb-0">
                        <thead>
                            <tr className="align-middle border-bottom TableHeader">
                                <th className="text-start ps-3">{t("Recruiters")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {teamLeadsData.teamLeads.map((teamLead: User, index) => (
                                <tr onClick={(e) => { setCurrentTeamLead(teamLead.id) }} key={index} className="cursor-pointer">
                                    <td>{teamLead.name}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div> 
                
                <TableTitle
                    title={currentTLData?.name}
                    tableTitleClassName="border py-3 text-center tableTitle TableHeader mb-2"
                />
                <StartersTable data={getStarters(currentTLData?.id ?? 0)} view="tl" tableTitle={t("Starters")} />
                <StoppersTable data={getStoppers(currentTLData?.id ?? 0)} view="tl" tableTitle={t("Stopper")} /> */}

        {teamLeadsData.teamLeads.map((teamLead: User, index) => (
          <Accordion className="mb-3">
            <Accordion.Item eventKey="">
              <Accordion.Header className="rounded-3 text-center align-items-center">
                <strong>{teamLead.name}</strong>
              </Accordion.Header>
              <Accordion.Body className="bg-white rounded-3">
                <StartersTable
                  data={getStarters(teamLead.id)}
                  view="tl"
                  tableTitle={t("Starters")}
                />
                <StoppersTable
                  data={getStoppers(teamLead.id)}
                  view="tl"
                  tableTitle={t("Stopper")}
                />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        ))}
      </div>
      <div className="row my-3">
        <div className="col-12">
          <JobInterviewTable
            data={teamLeadsData.jobInterviews}
            view="tl"
            tableTitle={t("Job interviews")}
          />
        </div>
      </div>
    </AccessControl>
  );
};

export default WeeklyReports;
